var defaultState = {
  miniPlayer: null
}

export const mutations = {
  setMiniPlayer (state, miniPlayer) {
    state.miniPlayer = miniPlayer
  }
}

export const getters = {
  miniPlayer: state => state.miniPlayer
}

export const actions = {
}

export default {
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/player.js